/* ============================================================
   FinishSetupCard bare-workspace dismiss marker (TASK 2026-09-11,
   bare-brand-prompts #2). Mirrors OnboardingNudge.jsx's per-user
   localStorage dismiss pattern: a small, storage-only module so both
   Dashboard.jsx (reads it to decide whether to show the card) and
   FinishSetupCard.jsx (writes it on "×" click) share one key format and
   the same 7-day window (lib/finishSetup.js's BARE_WORKSPACE_HIDE_MS,
   read back through isBareWorkspaceHidden — kept there, pure and
   tested, so this file stays pure I/O).
   ============================================================ */
const HIDE_KEY_PREFIX = 'dathent.finishSetup.hidden';

function hideKey(userId) {
  return `${HIDE_KEY_PREFIX}.${userId || 'anon'}`;
}

export function readBareWorkspaceHiddenAt(userId) {
  try {
    return window.localStorage.getItem(hideKey(userId)) || null;
  } catch (_) {
    return null;
  }
}

export function writeBareWorkspaceHiddenAt(userId, now = new Date()) {
  try {
    window.localStorage.setItem(hideKey(userId), now.toISOString());
  } catch (_) { /* storage unavailable — worst case the card reappears sooner */ }
}
